//设备看板-地锁统计数据
import React, { Component } from "react";
import { Spin, Tooltip } from "antd";
// 接口以及调用接口方法
import { queryLockNumQry } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
// 组件
import NoData from "@/components/common/no_data";
// icon
import Echarts from "echarts";
import { QuestionCircleFilled } from "@ant-design/icons";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import "@/assets/stylus/displayBoard.styl";
// eslint-disable-next-line arrow-parens
@connect((state) => state)
class DeviceInfoSub extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.chartId = this.props.chartId ? this.props.chartId : ""; // 设置告警饼图 id
    this.state = {
      showSping: true, // loading加载是否显示：true，显示，false，不显示
      param: {
        cityIds: this.props.param.cityIds,
        provinceIds: this.props.param.provinceIds, // 默认 000000全国
        date: this.props.param.date,
        isMonth: this.props.param.isMonth,
        operationProperty: this.props.param.operationProperty,
        operationMode: this.props.param.operationMode,
      },
      pieData: [
      //   {
			// 	"day": "2023-04-10",
			// 	"camsNum": 1,
			// 	"lyNum": 2,
			// 	"hbNum": 3,
			// 	"wkNum": 4,
			// 	"ddNum": 5,
			// 	"hwNum": 6,
			// 	"twoNum": 7,
			// 	"totalNum": 30
			// }, {
			// 	"day": "2023-04-11",
			// 	"camsNum": 1,
			// 	"lyNum": 2,
			// 	"hbNum": 3,
			// 	"wkNum": 4,
			// 	"ddNum": 5,
			// 	"hwNum": 6,
			// 	"twoNum": 7,
			// 	"totalNum": 4
			// }, {
			// 	"day": "2023-04-12",
			// 	"camsNum": 1,
			// 	"lyNum": 2,
			// 	"hbNum": 3,
			// 	"wkNum": 4,
			// 	"ddNum": 5,
			// 	"hwNum": 6,
			// 	"twoNum": 7,
			// 	"totalNum": 12
			// }
    ],
      noData: false,
      totalNum:0,
      twoNum:0,
      hwNum:0,
      ddNum:0,
      wkNum:0,
      hbNum:0,
      lyNum:0,
      camsNum:0,
      onLineNum:0,
      errorNum:0,
      
      twoNumRate:0,
      hwNumRate:0,
      ddNumRate:0,
      wkNumRate:0,
      hbNumRate:0,
      lyNumRate:0,
      onLineNumRate:0,
      errorNumRate:0,
      camsNumRate:0
    };
  }

  // 父组件修改param时执行
  componentWillReceiveProps(nextProps) {
    console.info('ueueue')
    if (
      nextProps.param.provinceIds === this.state.param.provinceIds &&
      nextProps.param.cityIds === this.state.param.cityIds &&
      nextProps.param.stubType === this.state.param.stubType &&
      nextProps.param.operationMode === this.state.param.operationMode &&
      nextProps.param.date === this.state.param.date
    ) {
      // console.log("饼图数据一样");
    } else {
      if ((nextProps.param.cityIds== null || nextProps.param.cityIds == '') && (nextProps.param.provinceIds== null || nextProps.param.provinceIds == ''))
      {
        this.setState(
          {
            totalNum:0,
            twoNumRate:0,
            hwNumRate:0,
            ddNumRate:0,
            wkNumRate:0,
            hbNumRate:0,
            lyNumRate:0,
            camsNumRate:0,
            onLineNumRate:0,
            errorNumRate:0,
            twoNum:0,
            errorNum:0,
            onLineNum:0,
            hwNum:0,
            camsNum:0,
            lyNum:0,
            hbNum:0,
            wkNum:0,
            ddNum:0,
            pieData: [],
            noData: true,
          },
          () => {
            this.renderChart();
          },
        );
        return;
      }
      this.setState(
        {
          showSping: true, // loading加载是否显示：true，显示，false，不显示
          param: {
            stubType:nextProps.param.stubType,
            cityIds: nextProps.param.cityIds,
            provinceIds: nextProps.param.provinceIds, // 默认 000000全国
            date: nextProps.param.date,
            operationProperty: nextProps.param.operationProperty,
            operationMode: nextProps.param.operationMode,
          },
        },
        () => {
          this.getPieDate();
        },
      );
    }
  }

  // 获取数据
  getPieDate() {
    const func = queryLockNumQry;
    var params = {
      startTime: this.state.param.date,
      cityIds: this.state.param.cityIds,
      operationProperty: this.state.param.operationProperty,
      provinceIds: this.state.param.provinceIds,
      isMonth: this.state.param.isMonth,
    };
    if (this.state.param.stubType != null && this.state.param.stubType != '')
    {
      params.stubType = this.state.param.stubType;
    }
    if (this.state.param.operationMode != null && this.state.param.operationMode != '')
    {
      params.operationMode = this.state.param.operationMode;
    }
    // 获取成功率趋势数据
    fetchHandler(func, params).then((res) => {
      this.setState({
        showSping: false, // loading加载是否显示：true，显示，false，不显示
      });
      if (res.data) {
        if (res.data.nearNumChangeList && res.data.nearNumChangeList.length > 0)
        {
          localStorage.setItem('pieData', JSON.stringify(res.data.nearNumChangeList.reverse()));
        } else {
          localStorage.setItem('pieData', JSON.stringify([]));
        }
        
        var total = parseInt(res.data.camsLockNum) + parseInt(res.data.camsLockTwoNum) + parseInt(res.data.ddLockNum)
        + parseInt(res.data.haoLockNum) + parseInt(res.data.hbLockNum) + parseInt(res.data.lyLockNum) + parseInt(res.data.wkLockNum);
        total = parseInt(total);
        var twoNumRate = parseInt(res.data.camsLockTwoNum) == 0 ? 0 : (total == 0 ? 0 : ((res.data.camsLockTwoNum/total * 100).toFixed(2)));
        var hwNumRate = parseInt(res.data.haoLockNum) == 0 ? 0 : (total == 0 ? 0 : ((res.data.haoLockNum/total * 100).toFixed(2)));
        var ddNumRate = parseInt(res.data.ddLockNum) == 0 ? 0 : (total == 0 ? 0 : ((res.data.ddLockNum/total * 100).toFixed(2)));
        var wkNumRate = parseInt(res.data.wkLockNum) == 0 ? 0 : (total == 0 ? 0 : ((res.data.wkLockNum/total * 100).toFixed(2)));
        var hbNumRate = parseInt(res.data.hbLockNum) == 0 ? 0 : (total == 0 ? 0 : ((res.data.hbLockNum/total * 100).toFixed(2)));
        var lyNumRate = parseInt(res.data.lyLockNum) == 0 ? 0 : (total == 0 ? 0 : ((res.data.lyLockNum/total * 100).toFixed(2)));


        
        var onLineNumRate = parseInt(res.data.onLineNum) == 0 ? 0 : (total == 0 ? 0 : ((res.data.onLineNum/total * 100).toFixed(2)));
        var errorNumRate = parseInt(res.data.errorNum) == 0 ? 0 : (total == 0 ? 0 : ((res.data.errorNum/total * 100).toFixed(2)));
        
        var camsNumRate = total == 0 ? 0 : (100-twoNumRate-hwNumRate-ddNumRate-wkNumRate-hbNumRate-lyNumRate).toFixed(2);
        this.setState(
          {
            totalNum:parseInt(res.data.camsLockNum) + parseInt(res.data.camsLockTwoNum) + parseInt(res.data.ddLockNum)
            + parseInt(res.data.haoLockNum) + parseInt(res.data.hbLockNum) + parseInt(res.data.lyLockNum) + parseInt(res.data.wkLockNum),
            twoNumRate:twoNumRate,
            hwNumRate:hwNumRate,
            ddNumRate:ddNumRate,
            wkNumRate:wkNumRate,
            hbNumRate:hbNumRate,
            lyNumRate:lyNumRate,
            camsNumRate:camsNumRate,
            onLineNumRate:onLineNumRate,
            errorNumRate:errorNumRate,
            twoNum:res.data.camsLockTwoNum,
            errorNum:res.data.errorNum,
            onLineNum:res.data.onLineNum,
            hwNum:res.data.haoLockNum,
            camsNum:res.data.camsLockNum,
            lyNum:res.data.lyLockNum,
            hbNum:res.data.hbLockNum,
            wkNum:res.data.wkLockNum,
            ddNum:res.data.ddLockNum,
            pieData: (res.data.nearNumChangeList && res.data.nearNumChangeList.length > 0) ? res.data.nearNumChangeList : [],
            noData: !res.data.nearNumChangeList.length > 0,
          },
          () => {
            this.renderChart();
          },
        );
      } else {
        this.setState({
          noData: true,
        });
      }
    });
    // this.setState({
    //   showSping: false, // loading加载是否显示：true，显示，false，不显示
    // });
    // this.renderChart();
  }

  componentDidMount() {
    this.getPieDate();
  }

  //  故障等级排布饼图
  renderChart() {
    if (document.getElementById(`pie${this.chartId}`) && document.getElementById(`pie${this.chartId}`) != null)
    {
    this.titleLeft = document.getElementById(`pie${this.chartId}`).clientWidth * 0.3 - 28;
    }
    window.removeEventListener("resize", () => {});
    const { pieData } = this.state;
    // 数据设置
    let data = [];
    let dataLen = [];
    let colors = [];

    if (pieData.length === 0) {
      data = [{ name: "暂无数据", value: 0 }];
      dataLen = [];
      colors = ["#d8d8d8"];
    } else {
      let len = 0;
      if (pieData.length > 8)
      {
        len = parseInt(pieData.length/8);
      }
      console.info('结果：' + len)
      // 数据
      pieData.map((item, index) => {
        data.push(item.totalNum);
        if (len == 0 || index == 0 || index == (pieData.length - 1) || (index + 1) % len == 0)
        {
          dataLen.push(item.day);
        } else {
          dataLen.push('');
        }
        // if (this.props.pieType === "1") {
        //   // 故障等级分布
        //   data.push({
        //     name: item.levenName,
        //     value: item.proportion,
        //   });
        //   dataLen.push({
        //     name: item.levenName,
        //     icon: "circle",
        //   });
        //   colors.push(item.color);
        //   return true;
        // } else {
        //   //  故障城市分布
        //   data.push({
        //     name: item.cityName,
        //     value: item.cityProportion ? item.cityProportion : 0,
        //   });
        //   dataLen.push({
        //     name: item.cityName,
        //     icon: "circle",
        //   });
        //   // colors.push(item.color);
        //   return true;
        // }
      });
    }

    const myChart = Echarts.init(document.getElementById(`pie${this.chartId}`));
    const option = {
      // 图表背景颜色
      // backgroundColor: '#ccc',
      title: {
          text: '',
          left: "center",
          textStyle: {
              color: '#1e80ff',
              fontSize: 24,

          }
      },
      tooltip: {
          trigger: 'axis',
          formatter: function(data) 
          {
            var pieData = JSON.parse(localStorage.getItem('pieData'));
            var one = pieData[data[0].dataIndex]
            return one.day + '<br/>新增总数：' + one.totalNum + '，开迈斯：'+ one.camsNum
            + '，<br/>蓝牙：'+ one.lyNum
            + '，慧铂金：'+ one.hbNum
            + '，万科：'+ one.wkNum
            + '，钉钉：'+ one.ddNum
            + '，<br/>豪伟：'+ one.hwNum
            + '，开迈斯第二代：'+ one.twoNum; //将小数转化为百分数显示
          }
      },
      legend: {
          data: [''],
          textStyle: {
              color: 'black',
          },
          orient: 'vertical',
          left: 'center',
          bottom:'bottom',
      },
      toolbox: {
          show: true,
          feature: {
              dataView: { show: true, readOnly: false },
              magicType: { show: true, type: ['line', 'bar'] },
              restore: { show: true },
              saveAsImage: { show: true }
          }
      },
      calculable: true,
      xAxis: [
          {
              name: '日期',
              nameTextStyle: {
                  padding: [20, 0, 0, 0],    // 四个数字分别为上右下左与原位置距离
                  // color:'green',
                  fontSize: 18,
              },
              type: 'category',
              // prettier-ignore
              data: dataLen,
              axisLabel: {
                  margin: 20,
                  interval: 0,
                  rotate: 20,
                  textStyle: {
                      //改变x轴上文字的颜色
                      // color: "green",
                      fontSize: 18,
                  }
              }
          }
      ],
      yAxis: [
          {
              name:'数量',
              nameTextStyle: {
                  padding: [20, 0, 0, 0],    // 四个数字分别为上右下左与原位置距离
                  color:'#1e80ff',
                  fontSize: 18,
              },

              type: 'value',
              axisLabel: {
                  textStyle: {
                      //改变y轴上文字的颜色
                      color: "#1e80ff",
                      fontSize: 18,
                  }
              },
              axisLine: {
                  show: true,//是否显示轴线
                  lineStyle: {
                      color: 'black',//刻度线的颜色
                  }
              }
          }
      ],
      series: [
          {
              name: '',
              type: 'bar',
              data: data,
              itemStyle: {
                  normal: {
                      color: '#1e80ff'
                  },
              },
              // markPoint: {
              //     data: [
              //         { type: 'max', name: 'Max' },
              //         { type: 'min', name: 'Min' }
              //     ]
              // },
              // markLine: {
              //     data: [{ type: 'average', name: 'Avg' }]
              // }
          }
          
      ]
  };
    myChart.clear();
    myChart.setOption(option);
    window.addEventListener("resize", () => {
      if (this.props.panelsInfo.activeKey === "0001") {
        if (document.getElementById(`pie${this.chartId}`) && document.getElementById(`pie${this.chartId}`) != null)
    {
        this.titleLeft = document.getElementById(`pie${this.chartId}`).clientWidth * 0.3 - 28;
        }
        myChart.resize();
      }
    });
  }

  render() {
    const content = (
      <div>
        <div style={{ fontSize: "18px", fontWeight:"500" }}>地锁统计</div>
        <div className='page-panel'>
          <div className='display-board'>
            <div className='item' style={{ width: "100%" }}>
              <div className='inner1' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                 
                  <div className='stub-info-item'>
                    <div className='name'>
                      地锁总数
                      
                    </div>
                    <div className='num'>{this.state.totalNum}</div>
                  </div>
                </div>
              </div>
              { this.state.camsNum > 0 && 
              <div className='inner1' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                 
                  <div className='stub-info-item'>
                    <div className='name'>
                      开迈斯
                      
                    </div>
                    <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                      <div className='num'>{this.state.camsNum}</div>
                      <div style={{ color:"#afa9a9"}}>{this.state.camsNumRate}%</div>
                    </div>
                  </div>
                </div>
              </div>
              }
{ this.state.lyNum > 0 && 
              <div className='inner1' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                 
                  <div className='stub-info-item'>
                    <div className='name'>
                    蓝牙
                      
                    </div>
                    <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                      <div className='num'>{this.state.lyNum}</div>
                      <div style={{ color:"#afa9a9"}}>{this.state.lyNumRate}%</div>
                    </div>
                  </div>
                </div>
              </div>
              }
              { this.state.hbNum > 0 && 
              <div className='inner1' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                 
                  <div className='stub-info-item'>
                    <div className='name'>
                    慧铂金
                      
                    </div>
                    <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                      <div className='num'>{this.state.hbNum}</div>
                      <div style={{ color:"#afa9a9"}}>{this.state.hbNumRate}%</div>
                    </div>
                  </div>
                </div>
              </div>
              }
              { this.state.wkNum > 0 && 
              <div className='inner1' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                 
                  <div className='stub-info-item'>
                    <div className='name'>
                    万科
                      
                    </div>
                    <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                      <div className='num'>{this.state.wkNum}</div>
                      <div style={{ color:"#afa9a9"}}>{this.state.wkNumRate}%</div>
                    </div>
                  </div>
                </div>
              </div>
              }
              { this.state.ddNum > 0 && 
              <div className='inner1' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                 
                  <div className='stub-info-item'>
                    <div className='name'>
                    钉钉
                      
                    </div>
                    <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                      <div className='num'>{this.state.ddNum}</div>
                      <div style={{ color:"#afa9a9"}}>{this.state.ddNumRate}%</div>
                    </div>
                  </div>
                </div>
              </div>
              }
              { this.state.hwNum > 0 && 
              <div className='inner1' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                 
                  <div className='stub-info-item'>
                    <div className='name'>
                    豪伟
                      
                    </div>
                    <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                      <div className='num'>{this.state.hwNum}</div>
                      <div style={{ color:"#afa9a9"}}>{this.state.hwNumRate}%</div>
                    </div>
                  </div>
                </div>
              </div>
              }
              { this.state.twoNum > 0 && 
              <div className='inner1' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                 
                  <div className='stub-info-item'>
                    <div className='name'>
                    开迈斯第二代
                      
                    </div>
                    <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                      <div className='num'>{this.state.twoNum}</div>
                      <div style={{ color:"#afa9a9"}}>{this.state.twoNumRate}%</div>
                    </div>
                  </div>
                </div>
              </div>
              }
              <div className='inner1' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                 
                  <div className='stub-info-item'>
                    <div className='name'>
                    在线<Tooltip
                        title={() => <span style={{ color: "#000" }}>地锁状态为排除故障、离网、未知的地锁数量占总地锁数量的比例</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                      
                    </div>
                    <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                      <div className='num'>{this.state.onLineNum}</div>
                      <div style={{ color:"#afa9a9"}}>{this.state.onLineNumRate}%</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='inner1' style={{ padding: "24px 2%" }}>
                
                <div className='detail-info stub-info-board'>
                 
                  <div className='stub-info-item'>
                    <div className='name'>
                    故障<Tooltip
                        title={() => <span style={{ color: "#000" }}>地锁状态为故障的地锁数量占总地锁数量的比例</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                      
                    </div>
                    <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                      <div className='num'>{this.state.errorNum}</div>
                      <div style={{ color:"#afa9a9"}}>{this.state.errorNumRate}%</div>
                    </div>
                  </div>
                </div>
              </div>



              
            </div>

            


          </div>
        </div>
        <div style={{ fontSize: "14px", fontWeight:"200" }}>月度新增地锁趋势 
        <Tooltip
                        title={() => <span style={{ color: "#000" }}>近30天每日各品牌地锁新增的数据柱状图</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip></div>
        <Spin spinning={this.state.showSping}>
          <div style={{ height: "321px" }} id={`pie${this.chartId}`}></div>
          {this.state.noData ? (
            <div className="no_data_com no_data_line no_border">
              <NoData />
            </div>
          ) : null}
        </Spin>
      </div>
    );

    return content;
  }
}

export default injectIntl(DeviceInfoSub);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/deviceInfoSub.js